import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Translation } from 'react-i18next';
import { Col, PageHeader, Row } from 'antd';

import Logger from '../../../../../lib/Logger';
import RegisterStep4 from '../containers/RegisterStep4FormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import QueryString from '../../../../../lib/QueryString';
import { pathTo } from '../../../Routes';
import imageLogo from '../../../assets/images/logo-300x300.png';
import Config from '../../../../../Config';
import '../styles/Register.less';

class RegisterStep4Screen extends Component {
  render() {
    const params = QueryString.parse(this.props.location.search);
    const cognitoId = 'cti' in params ? params.cti : null;
    const cognitoKey = 'ctk' in params ? params.ctk : null;
    const newUserRequirement = 'nwur' in params ? params.nwur : null;
    const cognitoFormId = 'cfi' in params ? params.cfi : null;
    const careGuideId = 'cid' in params ? params.cid : null;

    if (!cognitoId || !cognitoKey || !newUserRequirement) {
      return (
        <Redirect to={pathTo(Config.get('DEFAULT_REGISTRATION_REDIRECT'))} />
      );
    }

    return (
      <Translation>
        {(t) => (
          <div className='screen screen-public screen-register'>
            <DocumentHead title={t('register_route_step4')} />

            <PageHeader
              onBack={() =>
                this.props.history.push(pathTo('RegisterStep1Screen'))
              }
              title={t('register_screen_step4_page_title')}
              subTitle={t('register_screen_form4_header')}
            />

            <div className='logo'>
              <img
                src={imageLogo}
                height='42'
                alt={t('app_name')}
                className=''
              />
            </div>

            <div className='container-form-register'>
              <Row type='flex' justify='space-around' align='middle'>
                <Col xs={22} sm={18} md={16} lg={14} xl={8}>
                  <div class='outer-container'>
                    <div class='inner-container'>
                      <h1 style={{ fontWeight: 'bold' }}>
                        {t('register_screen_step4_title')}
                      </h1>
                      <h2>{t('register_screen_step4_subtitle')}</h2>

                      <RegisterStep4
                        cognitoId={cognitoId}
                        cognitoKey={cognitoKey}
                        cognitoFormId={cognitoFormId}
                        careGuideId={careGuideId}
                        newUserRequirement={parseInt(newUserRequirement)}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    Logger.log('silly', `RegisterStep4Screen.componentDidMount()`);
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }

  componentDidUpdate() {
    Logger.log('silly', `RegisterStep4Screen.componentDidUpdate()`);
  }

  componentWillUnmount() {
    Logger.log('silly', `RegisterStep4Screen.componentWillUnmount()`);
  }
}

export default RegisterStep4Screen;

Logger.log('silly', `RegisterStep4Screen loaded.`);
